import { render } from "./PoweredBy.vue?vue&type=template&id=c5acaaa2&scoped=true"
import script from "./PoweredBy.vue?vue&type=script&lang=js"
export * from "./PoweredBy.vue?vue&type=script&lang=js"

import "./PoweredBy.vue?vue&type=style&index=0&id=c5acaaa2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5acaaa2"]])

export default __exports__